import React from "react";
import Modal from "../../../../parts/modal-new";

const PhotoModal = ({ toggleModal = () => {}, photo, dontRefreshOnClose }) => {
  const { type, pictureImg } = photo;

  return (
    <Modal
      onClose={(e) => {
        e?.preventDefault?.();
        toggleModal();
      }}
      dontRefreshOnClose={dontRefreshOnClose || false}
      title={type}
      className={"preview-photo-modal"}
    >
      <div className="body">
        <img className="photo-modal-picture" alt="test" src={pictureImg} />
      </div>
    </Modal>
  );
};

export default PhotoModal;
